import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { SEARCH_PARAMETERS_API_IDS, STATUS_API_IDS } from '~/helpers/conversation';
import { useConversations } from '~/hooks/useConversations';
import { api } from '~/services/api';

const openStatus = STATUS_API_IDS.OPEN;
const closedStatus = [STATUS_API_IDS.CLOSED_BY_MERCHANT, STATUS_API_IDS.CLOSED_AUTO];
const openParams = { [SEARCH_PARAMETERS_API_IDS.STATUS]: openStatus };

export function useConversationSidebar({ activeMerchantId, params, changeParams, setSelectedConversation, navigateToConversationStatus }) {
  const queryClient = useQueryClient();
  const { isLoading, data } = useConversations(activeMerchantId, params);
  const { data: openData } = useConversations(activeMerchantId, openParams);

  const [searchNotFound, setSearchNotFound] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  const currentStatus = params[SEARCH_PARAMETERS_API_IDS.STATUS];
  const isOpenTab = currentStatus === openStatus || !currentStatus;

  const changeTab = (status) => changeParams({ [SEARCH_PARAMETERS_API_IDS.STATUS]: status });

  const handleSelectConversation = (conversationId) => {
    setSelectedConversation(conversationId);
    queryClient.setQueriesData({ queryKey: ['conversations', activeMerchantId] }, (old) => {
      if (!Array.isArray(old)) return old;
      return old.map((c) => (c.id === conversationId ? { ...c, read_by_merchant: true } : c));
    });
  };

  const searchByOrderNumber = async (value) => {
    if (!value) {
      setSearchNotFound(false);
      return false;
    }
    setIsSearching(true);
    setSearchNotFound(false);
    try {
      const res = await api.get(`/${activeMerchantId}/conversation/?${SEARCH_PARAMETERS_API_IDS.ORDER_ID}=${encodeURIComponent(value)}`);
      if (res.success && res.data?.length > 0) {
        const conversation = res.data[0];
        navigateToConversationStatus(conversation.status);
        handleSelectConversation(conversation.id);
        setIsSearching(false);
        return true;
      }
      setSearchNotFound(true);
      setIsSearching(false);
      return false;
    } catch {
      setSearchNotFound(true);
      setIsSearching(false);
      return false;
    }
  };

  const tabItems = [
    {
      label: 'En cours',
      active: isOpenTab,
      onClick: () => changeTab(openStatus),
      count: openData ? { value: openData.length, color: 'default' } : null,
      light: true,
    },
    {
      label: 'Clôturées',
      active: !isOpenTab,
      onClick: () => changeTab(closedStatus),
    },
  ];

  return { isLoading, data, isOpenTab, tabItems, handleSelectConversation, searchByOrderNumber, searchNotFound, isSearching };
}
